import { createFileRoute, Navigate } from "@tanstack/react-router";
import { parseSupportWorkbenchSearch } from "@/lib/supportWorkbenchSearch";
import { Route as SupportIndexRoute } from "@/routes/pulse-ops-x7k2.support.index";

export const Route = createFileRoute("/pulse-ops-x7k2/support/workbench")({
  validateSearch: parseSupportWorkbenchSearch,
  component: function SupportWorkbenchRedirect() {
    const search = Route.useSearch();
    return <Navigate to={SupportIndexRoute.to} search={search} replace />;
  },
});
